/**
 * Copy text string to clipboard from the target element
 */

export default (() => {
  const copyToClipboard = async (text, targetElement) => {
    try {
      await navigator.clipboard.writeText(text)
      return
    } catch (error) {
      if (!(targetElement instanceof HTMLInputElement) && !(targetElement instanceof HTMLTextAreaElement)) {
        throw error
      }
    }

    targetElement.select()

    if (!document.execCommand('copy')) {
      throw new Error('Unable to copy text to clipboard')
    }

    targetElement.setSelectionRange(0, 0)
  }

  const handleButtonClick = async (event) => {
    if (!(event.target instanceof Element)) {
      return
    }

    const button = event.target.closest('button[data-copy-text-from]')

    if (!(button instanceof HTMLButtonElement)) {
      return
    }

    const selector = button.dataset.copyTextFrom

    if (!selector) {
      return
    }

    const targetElement = document.querySelector(selector)

    if (!(targetElement instanceof HTMLElement)) {
      return
    }

    const textToCopy =
      targetElement instanceof HTMLInputElement || targetElement instanceof HTMLTextAreaElement ? targetElement.value : targetElement.textContent

    if (!textToCopy) {
      return
    }

    const originalInnerHTML = button.innerHTML
    const doneLabel = button.dataset.doneLabel || 'Copied'

    try {
      await copyToClipboard(textToCopy, targetElement)
      button.innerHTML = `<i class="ci-check me-1"></i> ${doneLabel}`

      window.setTimeout(() => {
        button.innerHTML = originalInnerHTML
      }, 2000)
    } catch (error) {
      console.error('Error in copying text: ', error)
    }
  }

  document.addEventListener('click', handleButtonClick)
})()
